import OriginalRupee, { rupees as originalRupees } from '@instamojo/rupee';
import React from 'react';

const Rupee: React.FC = (props) => <OriginalRupee {...props} removeSpaceAfterRupee />;

export default Rupee;

export const rupees = originalRupees;
